(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Alcott Black gallery workaround — see the capture comment near the
    // top of this file for why this exists and how to remove it once
    // real Black-variant photos are uploaded in Shopify Admin.
    document.querySelectorAll('[id$="__main"] [data-alcott-black-gallery]').forEach((gallery) => {
      const media = gallery.closest('.product-information__media');
      const colorInputs = media
        ?.closest('.product-information__grid, [id$="__main"]')
        ?.querySelectorAll('.variant-option--swatches input[name*="Color" i]');
      const images = gallery.querySelectorAll('[data-alcott-black-slide]');
      const thumbs = gallery.querySelectorAll('[data-alcott-black-thumb]');
      const prevButton = gallery.querySelector('[data-alcott-black-prev]');
      const nextButton = gallery.querySelector('[data-alcott-black-next]');
      let current = 0;

      function setSlide(index) {
        current = Number(index);
        images.forEach((img) => img.classList.toggle('is-active', img.dataset.alcottBlackSlide === String(current)));
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.alcottBlackThumb === String(current)));
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setSlide(thumb.dataset.alcottBlackThumb));
      });

      prevButton?.addEventListener('click', () => {
        setSlide((current - 1 + images.length) % images.length);
      });

      nextButton?.addEventListener('click', () => {
        setSlide((current + 1) % images.length);
      });

      function syncVisibility() {
        const checked = [...(colorInputs || [])].find((input) => input.checked);
        const isBlack = checked?.value?.trim().toLowerCase() === 'black';
        gallery.classList.toggle('is-visible', !!isBlack);
        gallery.setAttribute('aria-hidden', isBlack ? 'false' : 'true');
      }

      colorInputs?.forEach((input) => input.addEventListener('change', syncVisibility));
      syncVisibility();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
